/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { property } from 'lit/decorators.js';
import CDSSelect from '@carbon/web-components/es/components/select/select.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './footer.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Language selector component - mobile version.
 * The API for language selection is still subject to change.
 *
 * @element c4d-language-selector-mobile
 */
@customElement(`${c4dPrefix}-language-selector-mobile`)
class C4DLanguageSelectorMobile extends CDSSelect {
  /**
   * The shadow slot this language-selector should be in.
   */
  @property({ reflect: true })
  slot = 'language-selector';

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

export default C4DLanguageSelectorMobile;
